export const splitByCapitalLetters = (str: string) => {
    return str.split(/(?=[A-Z])/).join(' ');
};
